import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@sm/wds-react';
import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles(theme => {
  return {
    backgroundTheming: {
      background: theme?.primaryBackgroundColor,
    },
  };
});

const BackgroundThemeWrapper = props => {
  const { backgroundTheming } = useStyles();

  return <Container className={`${backgroundTheming} background-wrapper`}>{props.children}</Container>;
};

BackgroundThemeWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BackgroundThemeWrapper;
